import { Component } from '@angular/core';

@Component({
  selector: 'app-cpsid24',
  templateUrl: './cpsid24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class Cpsid24Component {

}
